<template>
    <div>
        <mml-base-header-sec></mml-base-header-sec>

        <div class="container-fluid base-container">
            <div class="base-box p-normal">

                <form class="w-100" v-on:keyup.enter="search">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group form-group-sm">
                                <label class="form-label">Речи и изрази у називу</label>
                                <input type="text" v-model="words_query" class="form-control full-width">
                            </div>
                            <div class="form-group form-group-sm">
                                <label class="form-label">Речи и изрази у тексту</label>
                                <input type="text" v-model="text_query" class="form-control full-width">
                            </div>
                            <div class="form-group form-group-sm">
                                <label class="form-label">Основни пропис</label>
                                <input type="text" v-model="principal_act" class="form-control full-width">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group form-group-sm">
                                <label class="form-label">Доносилац / Аутор</label>
                                <select v-model="authorityGroup" class="form-control full-width">
                                    <option value="0">Све групе доносилаца</option>
                                    <option v-for="item in filters.authorityGroups" v-bind:key="item.k" :value="item.k">
                                        {{ item.l }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group form-group-sm">
                                <label class="form-label">Назив доносиоца / Име аутора</label>
                                <select v-model="authority" class="form-control full-width">
                                    <option value="0">Сви доносиоци</option>
                                    <option v-for="item in filters.authorities" v-bind:key="item.k" :label="item.l"
                                        :value="item.k">{{ item.l }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group form-group-sm" v-if="filters.subjects.length !== 0">
                                <label class="form-label">Материја</label>
                                <select v-model="subject" class="form-control full-width">
                                    <option v-for="item in filters.subjects" v-bind:key="item.k" :value="item.k">
                                        {{ item.l }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group form-group-sm">
                                <label class="form-label">Тип документа</label>
                                <select v-model="documentType" class="form-control full-width">
                                    <option value="0">Актуелни</option>
                                    <option value="1">Архивски</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group form-group-sm">
                                <label class="form-label">Пронаћи</label>
                                <div><label class="form-label">
                                        <input type="checkbox" v-model="ac" @change="toggleAll"> Све </label>
                                </div>
                                <div><label class="form-label">
                                        <input type="checkbox" v-model="oc" @change="toggleCategory"> Мишљења и друге акте
                                    </label>
                                </div>
                                <div><label class="form-label">
                                        <input type="checkbox" v-model="qc" @change="toggleCategory"> Питања и одговоре
                                    </label>
                                </div>
                                <div><label class="form-label">
                                        <input type="checkbox" v-model="mc" @change="toggleCategory"> Моделе уговора и
                                        других аката </label>
                                </div>
                                <div><label class="form-label">
                                        <input type="checkbox" v-model="lc" @change="toggleCategory"> Литературу </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spacer20"></div>
                    <div class="d-md-flex justify-content-between align-items-center">
                        <div class="form-group form-group-sm ">
                            <div class="form-inline ">
                                <label for="search_size" class="form-label mr-2">Величина резултата</label>
                                <select v-model="resultLimit" class="form-control">
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                    <option value="300">300</option>
                                    <option value="400">400</option>
                                    <option value="500">500</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group form-group-sm ">
                            <!--                            <button type="button" class="btn btn-base-submit text-uppercase mr-3" @click="search">-->
                            <!--                                <span class="icon-search mr-2"></span>-->
                            <!--                                Претрага-->
                            <!--                            </button>-->


                            <button type="button" class="btn btn-base-submit text-uppercase mr-3" @click="search"
                                v-if="canOpen === 'can_open'">
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </button>
                            <button type="button" class="btn btn-base-submit text-uppercase mr-3"
                                v-if="canOpen === 'not_logged_in'" v-b-modal.login-modal href="#" @click.stop.prevent>
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </button>
                            <button type="button" class="btn btn-base-submit text-uppercase mr-3"
                                v-if="canOpen === 'role_not_allowed'" href="#" @click.stop.prevent="role_not_allowed()">
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </button>


                            <button type="button" class="btn btn-base-reset text-uppercase" @click="reset">
                                <span class="icon-rotate-cw mr-2"></span>
                                Поништи све
                            </button>
                        </div>
                    </div>
                </form>

            </div>

            <result-counter :count="resultSize" :limit="showNumResults"></result-counter>
            <div class="base-box base-box__table-sec" v-if="result.length > 0">
                <!--                <sorted-table :values="result"-->
                <!--                              sort="type"-->
                <!--                              dir="asc"-->
                <!--                              class="table  table-striped table-sm table-slglrs"-->
                <!--                              ascIcon="<span> ▲</span>"-->
                <!--                              descIcon="<span> ▼</span>">-->
                <!--                    <thead>-->
                <!--                    <tr>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="type">Bрста</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="authority">Назив доносиоца / Име аутора</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="principalAct">Основни пропис</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="closerDesignation">Ближе одређење материје / назив</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="sourceName">Начин објаве</sort-link>-->
                <!--                        </th>-->
                <!--                    </tr>-->
                <!--                    </thead>-->
                <!--                    <template #body="sort">-->
                <!--                        <tbody>-->
                <!--                        <tr v-for="(item, index) in sort.values" v-bind:key="index">-->
                <!--                            <td>{{item.type}}</td>-->
                <!--                            <td>{{item.authority}}</td>-->
                <!--                            <td>{{item.principalAct}}</td>-->
                <!--                            <td>-->
                <!--                                &lt;!&ndash;                                <a :href="baseApiUrl + 'mml/viewAct/' + item.id" target="_blank">&ndash;&gt;-->
                <!--                                &lt;!&ndash;                                    {{item.closerDesignation}}&ndash;&gt;-->
                <!--                                &lt;!&ndash;                                </a>&ndash;&gt;-->
                <!--                                <a :href="baseUrl +'mml/viewAct/naziv-akta/' + item.id" target="_blank">-->
                <!--                                    {{item.closerDesignation}}-->
                <!--                                </a>-->
                <!--                            </td>-->
                <!--                            <td>{{item.sourceName}}</td>-->
                <!--                        </tr>-->
                <!--                        </tbody>-->
                <!--                    </template>-->
                <!--                </sorted-table>-->

                <b-table class="table-bootstrap-vue" striped bordered :items="result" :fields="fields" responsive="sm">
                    <template v-slot:cell(closerDesignation)="data">
                        <router-link target="_blank" :to="{ path: '/mml/viewAct/' + data.item.id }">{{
                            data.item.closerDesignation
                        }}</router-link>
                    </template>
                </b-table>


            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import MmlBaseHeaderSec from '@/base_pages/mml/MmlBaseHeaderSec.vue';
// import {SortedTable, SortLink} from "vue-sorted-table";
import ResultCounter from '@/partials/ResultCounter.vue';
import { mapState } from 'vuex';


// <sort-link name="type">Bрста</sort-link>
//     <sort-link name="authority">Назив доносиоца / Име аутора</sort-link>
// <sort-link name="principalAct">Основни пропис</sort-link>
// <sort-link name="closerDesignation">Ближе одређење материје / назив</sort-link>
// <sort-link name="sourceName">Начин објаве</sort-link>
export default {
    name: "MmlStandardSearchPage",
    data() {
        return {
            // sortBy: 'timestamp',
            // sortDesc: true,
            showNumResults: '',
            fields: [
                { label: 'Bрста', key: 'type', sortable: true },
                { label: 'Назив доносиоца / Име аутора', key: 'authority', sortable: true },
                { label: 'Основни пропис', key: 'principalAct', sortable: true },
                { label: 'Ближе одређење материје / назив', key: 'closerDesignation', sortable: true },
                { label: 'Начин објаве', key: 'sourceName', sortable: true },
            ],
            isActOpen: false,
            actHTML: '',
            result: [],
            resultSize: null,
            baseMMLApiUrl: window.env.VUE_APP_API_MML_DEV,
            baseDIApiUrl: window.env.VUE_APP_API_DI_DEV ,
            docTypes: [],

            principal_act: '',
            words_query: '',
            text_query: '',
            resultLimit: 50,

            documentType: 0, // aktuelni / arhivski
            subject: null,

            // Checkboxes:
            ac: true, // Sve
            oc: true, // Misljenja i druge akte
            qc: true, // Pitanja i odgovore
            mc: true, // Modele ugovora i drugih akata
            lc: true, // Litearturu

            authorityTypes: [],
            authorityGroup: 0,
            authority: 0,

            filters: {
                authorityGroups: [],
                authorities: [],
                subjects: []
            },
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    components: {
        MmlBaseHeaderSec,
        // SortedTable,
        // SortLink,
        ResultCounter
    },
    computed: {
        ...mapState(['userInfoState']),

        canOpen() {
            if (this.userInfoState) {
                if (this.userInfoState.roles.includes('LSD')) {
                    return 'can_open';
                } else {
                    return 'role_not_allowed';
                }
            } else {
                return 'not_logged_in';
            }
        },
    },
    methods: {
        role_not_allowed() {
            alert('Немате приступ овој бази');
        },
        fetchData() {
            axios.get(this.baseMMLApiUrl + 'prins/standardSearch/filter?archived=' + (this.documentType == 0 ? 'false' : 'true'))
                .then(response => {
                    this.filters.authorityGroups = response.data.authorityGroups;

                    this.authorityTypes = [];

                    this.authorityTypes[0] =
                        this.filters.authorities = response.data.authorityKinds;

                    this.reset();
                });
        },
        toggleCategory() {
            this.ac = this.oc && this.qc && this.mc && this.lc;
        },
        toggleAll() {
            this.oc = this.qc = this.mc = this.lc = this.ac;
        },
        search() {

            // Local DATA
            // let responseLocal = {
            //     "limit": 50,
            //     "resultSize": 10117,
            //     "result": [{
            //         "id": "11190",
            //         "type": "Питања и одговори",
            //         "authority": "Повереник за информације од јавног значаја и заштиту података о личности",
            //         "principalAct": "Закон о заштити података о личности",
            //         "closerDesignation": "Лице за заштиту података о личности",
            //         "sourceName": "Вебсајт Повереника",
            //         "date": "26.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11191",
            //         "type": "Питања и одговори",
            //         "authority": "Повереник за информације од јавног значаја и заштиту података о личности",
            //         "principalAct": "Закон о заштити података о личности",
            //         "closerDesignation": "Упутство за попуњавање и обрасци контролних листа",
            //         "sourceName": "Вебсајт Повереника",
            //         "date": "26.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11161",
            //         "type": "Образложење закона",
            //         "authority": "Народна скупштина",
            //         "principalAct": "Закон о изменама и допунама Закона о играма на срећу",
            //         "closerDesignation": "Разлози за доношење Закона о изменама и допунама Закона о играма на срећу",
            //         "sourceName": "\"Службени гласник РС\", број 91/2019",
            //         "date": "24.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11159",
            //         "type": "Образложење закона",
            //         "authority": "Народна скупштина",
            //         "principalAct": "Закон о изменама и допунама Закона о Централном регистру обавезног социјалног осигурања",
            //         "closerDesignation": "Разлози за доношење Закона о изменама и допунама Закона о Централном регистру обавезног социјалног осигурања",
            //         "sourceName": "\"Службени гласник РС\", број 91/2019",
            //         "date": "24.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11154",
            //         "type": "Образложење закона",
            //         "authority": "Народна скупштина",
            //         "principalAct": "Закон о јавним набавкама",
            //         "closerDesignation": "Разлози за доношење Закона о јавним набавкама",
            //         "sourceName": "\"Службени гласник РС\", број 91/2019",
            //         "date": "24.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11162",
            //         "type": "Образложење закона",
            //         "authority": "Народна скупштина",
            //         "principalAct": "Закон о изменама и допунама Закона о дувану",
            //         "closerDesignation": "Разлози за доношење Закона о изменама и допунама Закона о дувану",
            //         "sourceName": "\"Службени гласник РС\", број 91/2019",
            //         "date": "24.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11157",
            //         "type": "Образложење закона",
            //         "authority": "Народна скупштина",
            //         "principalAct": "Закон о изменама и допунама Закона о спречавању прања новца и финансирања тероризма",
            //         "closerDesignation": "Разлози за доношење Закона о изменама и допунама Закона о спречавању прања новца и финансирања тероризма",
            //         "sourceName": "\"Службени гласник РС\", број 91/2019",
            //         "date": "24.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11158",
            //         "type": "Образложење закона",
            //         "authority": "Народна скупштина",
            //         "principalAct": "Закон о изменама и допунама Закона о роковима измирења новчаних обавеза у комерцијалним трансакцијама",
            //         "closerDesignation": "Разлози за доношење Закона о изменама и допунама Закона о роковима измирења новчаних обавеза у комерцијалним трансакцијама",
            //         "sourceName": "\"Службени гласник РС\", број 91/2019",
            //         "date": "24.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11155",
            //         "type": "Образложење закона",
            //         "authority": "Народна скупштина",
            //         "principalAct": "Закон о изменама и допунама Закона о привредним друштвима",
            //         "closerDesignation": "Разлози за доношење Закона о изменама и допунама Закона о привредним друштвима",
            //         "sourceName": "\"Службени гласник РС\", број 91/2019",
            //         "date": "24.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11163",
            //         "type": "Образложење закона",
            //         "authority": "Народна скупштина",
            //         "principalAct": "Закон о изменама и допуни Закона о Централној евиденцији стварних власника",
            //         "closerDesignation": "Разлози за доношење Закона о изменама и допуни Закона о Централној евиденцији стварних власника",
            //         "sourceName": "\"Службени гласник РС\", број 91/2019",
            //         "date": "24.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11165",
            //         "type": "Образложење закона",
            //         "authority": "Народна скупштина",
            //         "principalAct": "Закон о изменама и допуни Закона о посредовању у промету и закупу непокретности",
            //         "closerDesignation": "Разлози за доношење Закона о изменама и допуни Закона о посредовању у промету и закупу непокретности",
            //         "sourceName": "\"Службени гласник РС\", број 91/2019",
            //         "date": "24.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11156",
            //         "type": "Образложење закона",
            //         "authority": "Народна скупштина",
            //         "principalAct": "Закон о изменама и допунама Закона о јавном дугу",
            //         "closerDesignation": "Разлози за доношење Закона о изменама и допунама Закона о јавном дугу",
            //         "sourceName": "\"Службени гласник РС\", број 91/2019",
            //         "date": "24.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11160",
            //         "type": "Образложење закона",
            //         "authority": "Народна скупштина",
            //         "principalAct": "Закон о допунама Закона о Царинској тарифи",
            //         "closerDesignation": "Разлози за доношење Закона о допунама Закона о Царинској тарифи",
            //         "sourceName": "\"Службени гласник РС\", број 91/2019",
            //         "date": "24.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11169",
            //         "type": "Образложење закона",
            //         "authority": "Народна скупштина",
            //         "principalAct": "Закон о давању гаранције Републике Србије у корист Banca Intesa a.d. Beograd и Raiffeisen banka a.d. Beograd по задужењу Јавног предузећа „Србијагас” Нови Сад, по основу уговора о кредиту за изградњу разводног гасовода Александровац – Брус – Копаоник – Рашка – Нови Пазар – Тутин (III фаза)",
            //         "closerDesignation": "Разлози за доношење Закона о давању гаранције Републике Србије у корист Banca Intesa а.д. Београд и Raiffeisen banka а.д. Београд по задужењу јавног предузећа „Србијагас” нови сад, по основу уговора о кредиту за изградњу разводног гасовода Александровац – Брус – Копаоник – Рашка – Нови пазар – Тутин (III фаза)",
            //         "sourceName": "\"Службени гласник РС\", број 91/2019",
            //         "date": "24.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11164",
            //         "type": "Образложење закона",
            //         "authority": "Народна скупштина",
            //         "principalAct": "Закон о допунама Закона о прекршајима",
            //         "closerDesignation": "Разлози за доношење Закона о допунама Закона о прекршајима",
            //         "sourceName": "\"Службени гласник РС\", број 91/2019",
            //         "date": "24.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11195",
            //         "type": "Извештај",
            //         "authority": "Комисија за заштиту конкуренције",
            //         "principalAct": "Закон о енергетици",
            //         "closerDesignation": "Извештај о секторској анализи тржишта трговине на мало дериватима нафте у 2018. години",
            //         "sourceName": "Вебсајт Комисије",
            //         "date": "23.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11197",
            //         "type": "Обавештење",
            //         "authority": "Републички геодетски завод",
            //         "principalAct": "Закон о републичким административним таксама",
            //         "closerDesignation": "Документа Републичког геодетског завода – Измене и допуне Закона о Републичким административним таксама",
            //         "sourceName": "Вебсајт Завода",
            //         "date": "23.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11153",
            //         "type": "Обавештење",
            //         "authority": "Министарствo трговине, туризма и телекомуникација",
            //         "principalAct": "Закон о угоститељству",
            //         "closerDesignation": "Обавештење поводом доношења Правилника о садржини и начину подношења пријаве за некатегорисани угоститељски објекат за смештај, некатегорисани објекат за смештај наутичког туризма, некатегорисани објекат за смештај ловног туризма и о садржини и начину вођења евиденције објеката за смештај",
            //         "sourceName": "Вебсајт Министарства",
            //         "date": "20.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11147",
            //         "type": "Обавештење",
            //         "authority": "Министарство државне управе и локалне самоуправе",
            //         "principalAct": "Закон о буџету Републике Србије за 2020. годину",
            //         "closerDesignation": "Обавештење Министарства државне управе и локалне самоуправе о исплати отпремнина за одлазак у пензију у 2020. години",
            //         "sourceName": "Вебсајт Министарства",
            //         "date": "19.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11146",
            //         "type": "Стручни коментари",
            //         "authority": "Јасмина Стаменковић",
            //         "principalAct": "Закон о привредним друштвима",
            //         "closerDesignation": "Парнични поступак према ликвидационом дужнику",
            //         "sourceName": "Правно - информациони систем Републике Србије",
            //         "date": "18.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11142",
            //         "type": "План",
            //         "authority": "Министарство грађевинарства, саобраћаја и инфраструктуре",
            //         "principalAct": "Закон о међународном превозу у друмском саобраћају",
            //         "closerDesignation": "Годишњи план расподеле за 2020. годину донет на основу Уредбе о расподели страних дозвола за међународни јавни превоз ствари домаћим превозницима - Прелиминарни општи део плана расподеле дозвола за 2020. годину",
            //         "sourceName": "Вебсајт Министарства",
            //         "date": "17.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11139",
            //         "type": "Закони и прописи",
            //         "authority": "Проф. др Слободан Марковић",
            //         "principalAct": "Закон о ауторском и сродним правима",
            //         "closerDesignation": "Закон о ауторском и сродним правима, према стању законодавства од 26. септембра 2019. године (критички поглед на новеле Закона о ауторском и сродним правима)",
            //         "sourceName": "Закон о ауторском и сродним правима, прво издање",
            //         "date": "17.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11145",
            //         "type": "Обавештење",
            //         "authority": "Пореска управа",
            //         "principalAct": "Закон о републичким административним таксама",
            //         "closerDesignation": "Обавештење Пореске управе о неплаћању административних такси за издавање уверења електронским путем",
            //         "sourceName": "Вебсајт Управе",
            //         "date": "17.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11143",
            //         "type": "Обавештење",
            //         "authority": "Народна банка",
            //         "principalAct": "Одлука о адекватности капитала банке",
            //         "closerDesignation": "Обавештење Народне банке Србије поводом усвајања измена прописа ради подстицања кредитирања привреде у динарима",
            //         "sourceName": "Вебсајт Народне банке",
            //         "date": "16.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11152",
            //         "type": "Обавештење",
            //         "authority": "Управа царина",
            //         "principalAct": "Царински закон",
            //         "closerDesignation": "Обавештење о примени Инструкције о управљању тарифним квотама",
            //         "sourceName": "Вебсајт Управе",
            //         "date": "13.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11133",
            //         "type": "Образложење закона",
            //         "authority": "Народна скупштина",
            //         "principalAct": "Закон о изменама и допунама Закона о финансирању политичких активности",
            //         "closerDesignation": "Разлози за доношење Закона о изменама и допунама Закона о финансирању политичких активности",
            //         "sourceName": "\"Службени гласник РС\", број 88/2019",
            //         "date": "13.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11134",
            //         "type": "Образложење закона",
            //         "authority": "Народна скупштина",
            //         "principalAct": "Закон о изменама и допунама Закона о спречавању корупције",
            //         "closerDesignation": "Разлози за доношење Закона о изменама и допунама Закона о спречавању корупције",
            //         "sourceName": "\"Службени гласник РС\", број 88/2019",
            //         "date": "13.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11135",
            //         "type": "Образложење закона",
            //         "authority": "Народна скупштина",
            //         "principalAct": "Закон о изменама и допунама Закона о Агенцији за борбу против корупције",
            //         "closerDesignation": "Разлози за доношење Закона о изменама и допунама Закона о Агенцији за борбу против корупције",
            //         "sourceName": "\"Службени гласник РС\", број 88/2019",
            //         "date": "13.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11136",
            //         "type": "Образложење закона",
            //         "authority": "Народна скупштина",
            //         "principalAct": "Закон о допунама Закона о јавним предузећима",
            //         "closerDesignation": "Разлози за доношење Закона о допунама Закона о јавним предузећима",
            //         "sourceName": "\"Службени гласник РС\", број 88/2019",
            //         "date": "13.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11138",
            //         "type": "Обавештење",
            //         "authority": "Управа царина",
            //         "principalAct": "Закон о радијационој и нуклеарној сигурности и безбедности",
            //         "closerDesignation": "Обавештење Управе царина о примени Правилника о контроли радиоактивности робе приликом увоза, извоза и транзита („Сл. гласник РС\", бр. 86/19)",
            //         "sourceName": "Вебсајт Управе",
            //         "date": "13.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11132",
            //         "type": "Стручни коментари",
            //         "authority": "Милан Стефановић",
            //         "principalAct": "Закон о државној управи",
            //         "closerDesignation": "Мишљење надлежних органа о примени прописа",
            //         "sourceName": "Правно - информациони систем Републике Србије",
            //         "date": "12.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11148",
            //         "type": "Мишљење",
            //         "authority": "Повереник за заштиту равноправности",
            //         "principalAct": "Закон о забрани дискриминације",
            //         "closerDesignation": "Мишљење на Нацрт закона о правима бораца, војних инвалида, цивилних инвалида рата и чланова њихових породица",
            //         "sourceName": "Вебсајт Повереника",
            //         "date": "12.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11150",
            //         "type": "Предлози и иницијативе",
            //         "authority": "Повереник за заштиту равноправности",
            //         "principalAct": "Закон о забрани дискриминације",
            //         "closerDesignation": "Иницијатива Повереника за заштиту равноправности за измену јавноизвршитељске тарифе",
            //         "sourceName": "Вебсајт Повереника",
            //         "date": "12.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11126",
            //         "type": "Владавина права и посебна издања",
            //         "authority": "Доц. др Јелена С. Миленковић",
            //         "principalAct": "Закон о заштити права на суђење у разумном року",
            //         "closerDesignation": "Право на правично суђење у грађанским споровима",
            //         "sourceName": "Право на правично суђење у грађанским споровима, прво издање",
            //         "date": "11.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11137",
            //         "type": "Мишљење",
            //         "authority": "Заштитник грађана",
            //         "principalAct": "Закон о основним правима бораца, војних инвалида и породица палих бораца",
            //         "closerDesignation": "Мишљење на нацрт Закона о правима бораца, војних инвалида, цивилних инвалида рата и чланова њихових породица",
            //         "sourceName": "Вебсајт Заштитника",
            //         "date": "11.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11123",
            //         "type": "Стручни коментари",
            //         "authority": "Проф. др Гордана Станковић",
            //         "principalAct": "Породични закон",
            //         "closerDesignation": "Заштита права детета у поступцима грађанскоправне заштите",
            //         "sourceName": "Правно - информациони систем Републике Србије",
            //         "date": "10.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11125",
            //         "type": "Обавештење",
            //         "authority": "Агенција за привредне регистре",
            //         "principalAct": "Правилник о измени и допунама Правилника о садржини Регистра финансијског лизинга и документацији потребној за регистрацију",
            //         "closerDesignation": "Обавештење о електронској регистрацији уговора о финансијском лизингу од 1. јануара 2020. године",
            //         "sourceName": "Вебсајт Агенције",
            //         "date": "10.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11149",
            //         "type": "Мишљење",
            //         "authority": "Повереник за заштиту равноправности",
            //         "principalAct": "Закон о забрани дискриминације",
            //         "closerDesignation": "Мишљење на Нацрт закона о Меморијалном центру „Старо сајмиште“",
            //         "sourceName": "Вебсајт Повереника",
            //         "date": "10.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11144",
            //         "type": "Препорукa",
            //         "authority": "Заштитник грађана",
            //         "principalAct": "Закон о дивљачи и ловству",
            //         "closerDesignation": "Препоруке због пропуста у раду Ловачког удружења услед неблаговременог одлучивања о притужиочевом захтеву за накнаду штете коју му је проузроковала заштићена дивљач",
            //         "sourceName": "Вебсајт Заштитника",
            //         "date": "10.12.2019",
            //         "year": 2016
            //     }, {
            //         "id": "11122",
            //         "type": "Образложење закона",
            //         "authority": "Народна скупштина",
            //         "principalAct": "Закон о потврђивању Споразума о сарадњи између Републике Србије и Евроџаст-а",
            //         "closerDesignation": "Разлози за доношење Закона о потврђивању Споразума о сарадњи између Републике Србије и Евроџаст-а",
            //         "sourceName": "\"Службени гласник РС - Међународни уговори\", број 14/2019",
            //         "date": "09.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11140",
            //         "type": "Обавештење",
            //         "authority": "Управа царина",
            //         "principalAct": "Закон о порезу на додату вредност",
            //         "closerDesignation": "Обавештење о почетку реаализације Пилот пројекта \"Унапређење дигитализованог система повраћаја ПДВ путницима'' и поступање са Захтевом за повраћај ПДВ издатим на документу оператора",
            //         "sourceName": "Вебсајт Управе",
            //         "date": "09.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11141",
            //         "type": "Обавештење",
            //         "authority": "Управа царина",
            //         "principalAct": "Закон о изменама и допунама Закона о републичким административним таксама",
            //         "closerDesignation": "Обавештење Управе царине о најновијим изменама и допунама Закона о републичким административним таксама",
            //         "sourceName": "Вебсајт Управе",
            //         "date": "09.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11124",
            //         "type": "Обавештење",
            //         "authority": "Републички фонд за пензијско и инвалидско осигурање",
            //         "principalAct": "Закон о здравственом осигурању",
            //         "closerDesignation": "Обавештење Републичког фонда за пензијско и инвалидско осигурање поводом Одлуке о висини трошкова издавања картице здравственог осигурања",
            //         "sourceName": "Вебсајт Фонда",
            //         "date": "07.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11109",
            //         "type": "Образложење закона",
            //         "authority": "Народна скупштина",
            //         "principalAct": "Закон о измени Закона о привременом уређивању начина наплате таксе за јавни медијски сервис",
            //         "closerDesignation": "Разлози за доношење Закона о измени Закона о привременом уређивању начина наплате таксе за јавни медијски сервис",
            //         "sourceName": "\"Службени гласник РС\", број 86/2019",
            //         "date": "06.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11108",
            //         "type": "Образложење закона",
            //         "authority": "Народна скупштина",
            //         "principalAct": "Закон о изменама Закона о платама службеника и намештеника у органима аутономне покрајине и јединице локалне самоуправе",
            //         "closerDesignation": "Разлози за доношење Закона о изменама Закона о платама службеника и намештеника у органима аутономне покрајине и јединице локалне самоуправе",
            //         "sourceName": "\"Службени гласник РС\", број 86/2019",
            //         "date": "06.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11106",
            //         "type": "Образложење закона",
            //         "authority": "Народна скупштина",
            //         "principalAct": "Закон о изменама Закона о платама запослених у јавним агенцијама и другим организацијама које је основала Република Србија, аутономна покрајина или јединица локалне самоуправе",
            //         "closerDesignation": "Разлози за доношење Закона о изменама Законa о платама запослених у јавним агенцијама и другим организацијама које је основала Република Србија, аутономна покрајинa или јединица локалне самоуправе",
            //         "sourceName": "\"Службени гласник РС\", број 86/2019",
            //         "date": "06.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11107",
            //         "type": "Образложење закона",
            //         "authority": "Народна скупштина",
            //         "principalAct": "Закон о изменама Закона о систему плата запослених у јавном сектору",
            //         "closerDesignation": "Разлози за доношење Закона о изменама Закона о систему плата запослених у јавном сектору",
            //         "sourceName": "\"Службени гласник РС\", број 86/2019",
            //         "date": "06.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11105",
            //         "type": "Обавештење",
            //         "authority": "Повереник за информације од јавног значаја и заштиту података о личности",
            //         "principalAct": "Закон о слободном приступу информацијама од јавног значаја",
            //         "closerDesignation": "Обавештење Повереника за информације од јавног значаја и заштиту података о личности о достављању годишњих извештаја",
            //         "sourceName": "Вебсајт Повереника",
            //         "date": "06.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11120",
            //         "type": "Образложење закона",
            //         "authority": "Народна скупштина",
            //         "principalAct": "Закон o агенцијском запошљавању",
            //         "closerDesignation": "Разлози за доношење Закона o агенцијском запошљавању",
            //         "sourceName": "\"Службени гласник РС\", број 86/2019",
            //         "date": "06.12.2019",
            //         "year": 2019
            //     }, {
            //         "id": "11111",
            //         "type": "Образложење закона",
            //         "authority": "Народна скупштина",
            //         "principalAct": "Закон о изменама и допунама Закона о пореском поступку и пореској администрацији",
            //         "closerDesignation": "Разлози за доношење Закона о изменама и допунама Закона о пореском поступку и пореској администрацији",
            //         "sourceName": "\"Службени гласник РС\", број 86/2019",
            //         "date": "06.12.2019",
            //         "year": 2019
            //     }]
            // };
            // this.result = responseLocal.result;
            // this.resultSize = responseLocal.resultSize;

            const vm = this;
            var url = this.baseDIApiUrl + 'mml/standardSearch';
            var data = {
                aai: (this.subject === null) ? -1 : this.subject,
                agi: (this.authorityGroup === 0) ? -1 : this.authorityGroup,
                aki: (this.authority === 0) ? -1 : this.authority,
                ar: this.documentType,
                bk: this.text_query === '' ? null : this.text_query,
                tk: this.words_query === '' ? null : this.words_query,
                pa: this.principal_act === '' ? null : this.principal_act,
                lc: this.lc,
                mc: this.mc,
                oc: this.oc,
                qc: this.qc,
                limit: this.resultLimit
            };

            axios.post(url, data)
                .then(response => {
                    vm.result = response.data.result;
                    this.resultSize = response.data.resultSize;
                    this.showNumResults = response.data.limit;
                    console.log('show num mml', this.showNumResults);
                }).catch(error => {
                    if (error.response.status === 401) {
                        // nije ulogovan
                        // otvori modal za logovanje
                        vm.$root.$emit('bv::show::modal', 'login-modal', '#btnShow')
                    }
                });

        },
        reset() {
            this.authorityGroup = 0;
            this.authority = 0;
            this.subject = null;

            this.principal_act = '';

            if (this.$route.query.q) {
                this.words_query = this.$route.query.q;
            } else {
                this.words_query = '';
            }
            this.text_query = '';

            this.resultLimit = 50;

            this.result = [];
            this.resultSize = null;

        }
    },
    watch: {
        authorityGroup: function () {
            if (this.authorityTypes[this.authorityGroup] === undefined) {
                axios.get(this.baseMMLApiUrl + 'prins/standardSearch/filter?archived=' + (this.documentType == 0 ? 'false' : 'true') + '&authorityGroupId=' + this.authorityGroup)
                    .then(response => {
                        this.authorityTypes[this.authorityGroup] = response.data.authorityKinds;
                        this.filters.authorities = this.authorityTypes[this.authorityGroup];
                    });
            } else {
                this.filters.authorities = this.authorityTypes[this.authorityGroup];
            }
            this.authority = 0;
            this.subject = null;
        },
        authority: function () {
            this.filters.subjects = [];
            if (this.authority != 0) {
                axios.get(this.baseMMLApiUrl + 'prins/authorityArea/0/' + this.authority + '?archived=' + (this.documentType == 0 ? 'false' : 'true'))
                    .then(response => {
                        this.filters.subjects = response.data;

                        if (this.filters.subjects.length !== 0) {
                            this.subject = this.filters.subjects[0].k;
                        }
                    })
            }
        },
        documentType: function () {
            this.fetchData();
        }
    },
    created() {
        this.fetchData();
    },
    mounted() {
        if (this.$route.query.q) {
            this.words_query = this.$route.query.q;
            this.search();
        }
    },
    beforeCreate: function () {
        document.body.className = 'color_mml';
    }
}
</script>

<style>
.main {
    background-color: #ddd !important;
    padding-bottom: 360px !important;
}

.main {
    background-color: #ddd !important;
    padding-bottom: 360px !important;
}

.table-bootstrap-vue thead tr th:nth-child(1) {
    width: 10%;
}

.table-bootstrap-vue thead tr th:nth-child(2) {
    width: 20%;
}

.table-bootstrap-vue thead tr th:nth-child(3) {
    width: 30%;
}

.table-bootstrap-vue thead tr th:nth-child(4) {
    width: 30%;
}

.table-bootstrap-vue thead tr th:nth-child(5) {
    width: 10%;
}
</style>
